const locale = require('./proposalSummary.i18n.json');

/*@ngInject*/
const ProposalSummaryController = function ($scope, $rootScope, $timeout, $stateParams,
                                                           quoteMediator, submissionConstant, currencyUtil,
                                                           coreConstant, coreMediator, dateUtil,
                                                           appTypeConfigurationModel, proposalMediator) {

    $scope.i18n = locale;

    $scope.viewModel = {
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
        isLoading: true,
        quotes: [],
        isUnderwriter: appTypeConfigurationModel.isUnderwriterWorkstation(),
        proposal: {},
        proposalPremium: {}
    };

    function loadProposalPremium() {
        proposalMediator.findById($stateParams.proposalId).then(function (result) {
            result.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(result.totalPremium.currencyCode);
            $scope.viewModel.proposal = result;
            $scope.viewModel.proposalPremium = result.totalPremium;
            buildProposalName();
        });
    }

    function loadQuotes() {
        let submissionId = $stateParams.submissionId,
            proposalId = $stateParams.proposalId;

        $scope.viewModel.isLoading = true;

        quoteMediator.getQuoteList(submissionId, proposalId).then(function (quotes) {
            $scope.viewModel.quotes = _.map(quotes, function (quote) {
                quote.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat(quote.totalPremium.currencyCode);
                return quote;
            });
            $scope.viewModel.isLoading = false;
        });
    }

    function buildProposalName() {
        let description = $scope.viewModel.proposal.description;

        if ($scope.viewModel.proposal.quoteSummaries.length > 0) {
            description += ' (';
            _.each($scope.viewModel.proposal.quoteSummaries, function (quoteSummary, index) {
                if (index > 0) {
                    description += ', ';
                }
                description += quoteSummary.productShortName;
            });
            description += ')';
        }

        $scope.viewModel.proposalName = description;
    }


    $scope.openQuote = function (quote) {
        $rootScope.$broadcast(submissionConstant.event.OPEN_OWNER_URI, quote.objectUri);
    };

    $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, quoteSummary) {
        let index = _.indexOf($scope.viewModel.quotes, _.find($scope.viewModel.quotes, {id: quoteSummary.id}));
        $timeout(function () {
            if (index >= 0) {
                $scope.viewModel.quotes.splice(index, 1, quoteSummary);
            }
            else if (quoteSummary.proposalId === parseInt($stateParams.proposalId)) {
                $scope.viewModel.quotes.push(quoteSummary);
            }
        }, 0);
    });

    $scope.$on(coreConstant.event.QUOTE_DELETED, function (event, quoteSummary) {
        $timeout(function () {
            _.remove($scope.viewModel.quotes, {id: quoteSummary.id});
        }, 0);
    });

    loadQuotes();
    loadProposalPremium();
};

angular.module('gw-um-submission')
    .controller('proposalSummaryController', ProposalSummaryController);
